<template>
  <div>
    <div class="file_search">
      <a-input-search placeholder="按文件名搜索" style="width: 180px" v-model="fileName" @search="searchHandler" />
    </div>
    <div class="file_content">
      <div style="flex: auto">
        <a-table size="small" :loading="loading" :columns="columns" :dataSource="list" :pagination="false" :rowKey="row => row.id">
          <a-button  data-ga-id="项目-portfolio-点击文件" type="link" slot="name" slot-scope="row" @click="clickItem(row)">
            {{ row.name }}
          </a-button>
          <span slot="creator"></span>
          <span slot="sizeDesc" slot-scope="sizeDesc">{{ sizeDesc }}</span>
          <span slot="time" slot-scope="time">{{ time }}</span>
        </a-table>
        <div class="file_pagination" v-if="totalNum > 0">
          <a-pagination
            size="small"
            showSizeChanger
            :pageSize="pageSize"
            :total="totalNum"
            :current="currentPage"
            @change="changePage"
            @showSizeChange="changeSize"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getGatherList } from '@/api/document';
export default {
  props: {
    projectId: {
      type: String
    }
  },
  data() {
    return {
      columns: [
        { title: '文件名', scopedSlots: { customRender: 'name' }, width: 250 },
        {
          title: '上传人',
          dataIndex: 'creator',
          align: 'center',
          width: 50
        },
        {
          title: '文件大小',
          dataIndex: 'size',
          align: 'center',
          customRender: (text, record) => {
            if (text < 1024) {
              return text + 'KB';
            } else {
              return Math.floor(text / 1024) + 'MB';
            }
          },
          width: 70
        },
        {
          title: '上传时间',
          dataIndex: 'createAt',
          align: 'center',
          scopedSlots: { customRender: 'time' },
          width: 100
        }
      ],
      list: [],
      loading: false,
      documentList: [],
      pageSize: 10,
      totalNum: 0,
      currentPage: 1,
      fileName: ''
    };
  },
  mounted() {
    this.getList();
  },

  methods: {
    changePage(value) {
      this.currentPage = value;
      this.getList();
    },
    changeSize(page, size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.getList();
    },
    clickItem(item) {
      let routeLink = this.$router.resolve({ path: '/pdfview/finish', query: { id: item.id, taskId: item.taskId } });
      window.open(routeLink.href);
    },
    searchHandler() {
      this.$ga.gaUploadCustomEvent('项目-portfolio-搜索文件名');
      this.currentPage = 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      getGatherList({
        companyId: this.projectId,
        name: this.fileName,
        page: this.currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res.code === 200) {
            this.list = res.data.list;
            this.totalNum = res.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.file_search {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  align-items: center;
}
.file_content {
  display: flex;
  flex: auto;
  .ant-table-wrapper {
    width: 100%;
  }
  .ant-menu-vertical {
    border: none !important;
  }
}
.file_pagination {
  margin: 10px 0;
  text-align: right;
}
</style>
